import getSearchModalCurrentState from "./lib/getSearchModalCurrentState";
import listenForSearchModalEvent from "./lib/listenForSearchModalEvents";
import propagateSearchModalClose from "./lib/propagateSearchModalClose";
import propagateSearchModalOpen from "./lib/propagateSearchModalOpen";
import propagateSearchModalToggle from "./lib/propagateSearchModalToggle";

export { default as SearchModal } from "./components/SearchModal";
export { SearchWidget } from "./components/SearchWidget";
export {
  EVENT_SEARCH_MODAL_CLOSING,
  EVENT_SEARCH_MODAL_FINALIZED_INPUT,
  EVENT_SEARCH_MODAL_OPENING,
  EVENT_SEARCH_MODAL_USERINPUT,
  EVENT_SEARCH_SURPRISE_ME,
  HIDDEN_PROVIDERS,
  ITEMS_PER_PAGE,
  SEARCH_MODAL_HISTORY_KEY,
  SEARCH_MODAL_PREFETCH_KEY,
} from "./constants";
export type { GameFragment, ProviderFragment } from "./types";
export {
  getSearchModalCurrentState,
  listenForSearchModalEvent,
  propagateSearchModalClose,
  propagateSearchModalOpen,
  propagateSearchModalToggle,
};
